"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var template_1 = tslib_1.__importDefault(require("lodash/template"));
var get_1 = tslib_1.__importDefault(require("lodash/get"));
var MediaPreloader_1 = tslib_1.__importDefault(require("../../_common/MediaPreloader"));
var locale_1 = tslib_1.__importDefault(require("../../_utils/locale"));
var BannerWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    display: flex;\n    flex-wrap: wrap;\n"], ["\n    display: flex;\n    flex-wrap: wrap;\n"])));
var externalLink = function (url) { return /^https?:\/\//.test(url); };
var slide = function (banner, cdnTemplate) {
    var imagePath = banner.imagePath, videoPath = banner.videoPath;
    var imageUrl = banner.imageUrl, videoUrl = banner.videoUrl;
    if (videoPath && cdnTemplate) {
        var compileFromCdnTemplate = template_1.default(cdnTemplate);
        videoUrl = compileFromCdnTemplate({ path: videoPath });
    }
    if (imagePath && cdnTemplate) {
        var compileFromCdnTemplate = template_1.default(cdnTemplate);
        imageUrl = compileFromCdnTemplate({ path: imagePath });
    }
    if (videoUrl || (imageUrl && /\w*.mp4$/.test(imageUrl))) {
        return (react_1.default.createElement(BannerWrapper, null,
            react_1.default.createElement("video", { muted: true, loop: true, autoPlay: true },
                react_1.default.createElement("source", { src: videoUrl || imageUrl, type: "video/mp4" }))));
    }
    if (imageUrl) {
        return react_1.default.createElement("img", { src: imageUrl, alt: imageUrl });
    }
    return react_1.default.createElement("div", null);
};
var BannerSlide = function (_a) {
    var adContext = _a.adContext, apiLocale = _a.apiLocale, banner = _a.banner, cdnTemplate = _a.cdnTemplate, isoLocale = _a.isoLocale, tracking = _a.tracking;
    var _b = react_1.useState(null), ref = _b[0], setRef = _b[1];
    var slotId = banner.slotId;
    var imageUrl = banner.imageUrl, linkUrl = banner.linkUrl;
    var showAdLabel = false;
    var handleRef = react_1.useCallback(function (node) {
        if (slotId && node !== null) {
            setRef(node);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (adContext && slotId) {
        var adObserver = adContext.adObserver, fetched = adContext.fetched, getLinkUrl = adContext.getLinkUrl, getUrl = adContext.getUrl;
        imageUrl = getUrl(slotId);
        linkUrl = getLinkUrl(slotId);
        if (fetched && !imageUrl) {
            imageUrl = banner.imageUrl || '';
            linkUrl = banner.linkUrl || '';
            if (ref && adObserver && adObserver.current) {
                adObserver.current.unobserve(ref);
            }
            if (!imageUrl) {
                return null;
            }
        }
        else {
            showAdLabel = true;
        }
    }
    var renderLabel = function () {
        if (!adContext || !banner.label || (banner.label && !banner.label.text)) {
            return null;
        }
        var labelStyles = tslib_1.__assign(tslib_1.__assign({ position: 'absolute', padding: '0 4px', fontSize: '1rem' }, get_1.default(banner, 'label.position', {})), { backgroundColor: get_1.default(banner, 'label.bgColor', '#fff'), color: get_1.default(banner, 'label.textColor', '#828282') });
        return (react_1.default.createElement("div", { style: tslib_1.__assign({}, labelStyles) },
            react_1.default.createElement("span", null, banner.label.text)));
    };
    var handleMediaLoad = function () {
        if (adContext && slotId) {
            var adObserver = adContext.adObserver, trackImpression = adContext.trackImpression;
            trackImpression(slotId);
            if (ref && adObserver && adObserver.current) {
                adObserver.current.observe(ref);
            }
        }
    };
    var onBannerClick = function () {
        if (tracking && banner.gapt) {
            var trackingSet = banner && banner.gapt;
            var newTrackingSet = tslib_1.__assign(tslib_1.__assign({}, trackingSet), { id: trackingSet.name });
            tracking(apiLocale, {
                ecommerce: {
                    promoClick: {
                        promotions: [newTrackingSet],
                    },
                },
                platform: 'web',
            });
        }
    };
    if (linkUrl) {
        return (react_1.default.createElement("div", { ref: handleRef, "data-slotid": slotId },
            externalLink(linkUrl) ? (react_1.default.createElement("a", { href: linkUrl, onClick: onBannerClick, target: "_blank", rel: "noopener noreferrer" },
                react_1.default.createElement(MediaPreloader_1.default, { onLoad: handleMediaLoad, ratio: banner.ratio }, slide(tslib_1.__assign(tslib_1.__assign({}, banner), { imageUrl: imageUrl }), cdnTemplate)))) : (react_1.default.createElement("a", { href: "/" + locale_1.default.getSEOLocale(isoLocale) + linkUrl, onClick: onBannerClick },
                react_1.default.createElement(MediaPreloader_1.default, { onLoad: handleMediaLoad, ratio: banner.ratio }, slide(tslib_1.__assign(tslib_1.__assign({}, banner), { imageUrl: imageUrl }), cdnTemplate)))),
            showAdLabel ? renderLabel() : null));
    }
    return react_1.default.createElement("div", null);
};
exports.default = BannerSlide;
var templateObject_1;
//# sourceMappingURL=BannerSlide.js.map